import { Box } from '@mui/material';
import { useRecoilValue } from 'recoil';
import usePetImage from '~/hooks/image/usePetImage';
import { useRegistrationState } from '~/hooks/registration/useRegistrationStore';
import { secondaryImageState } from '~/state/atoms/image/imageAtoms';
import { OverlayLabel, OverlayRow } from '../OverlayLabel';
import { BlendingModeSelector, ImageBlendSlider } from './BlendingOptions';
import {
    PetBlendingLabel,
    PetBlendSlider,
} from './BlendingOptions/PetBlendingOptions';
import WindowingOptions from './WindowingOptions';

const ImageOptions = () => {
    const secondaryImage = useRecoilValue(secondaryImageState);
    const { isPetSecondary } = usePetImage();
    const registrationState = useRegistrationState();
    const registrationLabel =
        registrationState.selectedRegistration?.contentLabel;

    return (
        <Box display="grid" gap={0.5}>
            {secondaryImage && registrationLabel && (
                <OverlayRow sx={{ alignItems: 'center', px: 0.25, ml: -0.25 }}>
                    <OverlayLabel>Registration</OverlayLabel>
                    <OverlayLabel color="secondary.main">
                        {registrationLabel}
                    </OverlayLabel>
                </OverlayRow>
            )}
            {secondaryImage && isPetSecondary && <PetBlendingLabel />}
            {secondaryImage && !isPetSecondary && <BlendingModeSelector />}
            <Box display="flex" gap={0.5}>
                {secondaryImage && isPetSecondary && <PetBlendSlider />}
                {secondaryImage && !isPetSecondary && <ImageBlendSlider />}
                <WindowingOptions />
            </Box>
        </Box>
    );
};

export default ImageOptions;
